(function () {
  'use strict';

  if (!('customElements' in window)) return;

  function getFocusable(root) {
    return root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  var lockCount = 0;

  function lockScroll() {
    lockCount += 1;
    if (lockCount === 1) {
      document.documentElement.style.overflow = 'hidden';
    }
  }

  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.documentElement.style.overflow = '';
    }
  }

  class MainCollectionDrawerElement extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-mc-drawer-panel]');
      this.backdrop = this.querySelector('[data-mc-drawer-backdrop]');
      this.triggerEl = null;

      if (this.backdrop) {
        this.backdrop.addEventListener('click', this.close.bind(this));
      }

      var closeButtons = this.querySelectorAll('[data-mc-drawer-close]');
      for (var i = 0; i < closeButtons.length; i += 1) {
        closeButtons[i].addEventListener('click', this.close.bind(this));
      }

      this.addEventListener('keydown', this._handleKeydown.bind(this));
    }

    open(triggerEl) {
      if (this.getAttribute('data-open') === 'true') return;
      this.triggerEl = triggerEl || document.activeElement;
      this.setAttribute('data-open', 'true');
      lockScroll();

      var focusTarget = this.panel && this.panel.querySelector('[data-mc-drawer-close]');
      if (focusTarget) focusTarget.focus();
    }

    close() {
      if (this.getAttribute('data-open') !== 'true') return;
      this.setAttribute('data-open', 'false');
      unlockScroll();

      if (this.triggerEl && typeof this.triggerEl.focus === 'function') {
        this.triggerEl.focus();
      }
      this.triggerEl = null;
    }

    toggle(triggerEl) {
      if (this.getAttribute('data-open') === 'true') {
        this.close();
      } else {
        this.open(triggerEl);
      }
    }

    _handleKeydown(event) {
      if (this.getAttribute('data-open') !== 'true') return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key === 'Tab' && this.panel) {
        var focusable = getFocusable(this.panel);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }

  if (!customElements.get('main-collection-drawer')) {
    customElements.define('main-collection-drawer', MainCollectionDrawerElement);
  }

  function applyQuickviewTemplate(root, templateAttr, target, variantId) {
    if (!target) return;
    var template = root.querySelector('[' + templateAttr + '][data-variant-id="' + variantId + '"]');
    if (!template) return;
    target.innerHTML = '';
    target.appendChild(template.content.cloneNode(true));
  }

  function getQuickviewVariants(content) {
    var script = content.querySelector('[data-mc-quickview-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function findMatchingQuickviewVariant(content, variants) {
    var groups = content.querySelectorAll('[data-mc-quickview-option-group]');
    var selected = {};
    var i;
    for (i = 0; i < groups.length; i += 1) {
      var position = groups[i].getAttribute('data-option-position');
      var activeBtn = groups[i].querySelector('[data-mc-quickview-option][aria-pressed="true"]');
      selected[position] = activeBtn ? activeBtn.getAttribute('data-option-value') : null;
    }

    for (var v = 0; v < variants.length; v += 1) {
      var variant = variants[v];
      if (
        (selected['1'] == null || variant.option1 === selected['1']) &&
        (selected['2'] == null || variant.option2 === selected['2']) &&
        (selected['3'] == null || variant.option3 === selected['3'])
      ) {
        return variant;
      }
    }
    return null;
  }

  function updateQuickviewSelection(content) {
    var matched = findMatchingQuickviewVariant(content, getQuickviewVariants(content));

    var imageEl = content.querySelector('[data-mc-quickview-image]');
    var badgesEl = content.querySelector('[data-mc-quickview-badges]');
    var priceEl = content.querySelector('[data-mc-quickview-price]');
    var variantIdInput = content.querySelector('[data-mc-quickview-variant-id]');
    var addToCartBtn = content.querySelector('[data-mc-quickview-add-to-cart]');
    var viewDetailsLink = content.querySelector('[data-mc-quickview-view-details]');
    var unavailableNote = content.querySelector('[data-mc-quickview-unavailable]');
    var stockEl = content.querySelector('[data-mc-quickview-stock]');

    if (stockEl) {
      var stockText = matched && matched.available ? matched.stockText : '';
      stockEl.textContent = stockText || '';
      stockEl.hidden = !stockText;
    }

    if (matched) {
      applyQuickviewTemplate(content, 'data-mc-quickview-badges-template', badgesEl, matched.id);
      applyQuickviewTemplate(content, 'data-mc-quickview-price-template', priceEl, matched.id);
      if (variantIdInput) variantIdInput.value = matched.id;
      if (imageEl && matched.image) {
        imageEl.src = matched.image;
        if (matched.imageAlt) imageEl.alt = matched.imageAlt;
      }
      if (viewDetailsLink) {
        try {
          var url = new URL(viewDetailsLink.href, window.location.origin);
          url.searchParams.set('variant', matched.id);
          viewDetailsLink.href = url.pathname + url.search;
        } catch (error) {
          /* noop */
        }
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !matched.available;
        addToCartBtn.textContent = matched.available
          ? addToCartBtn.getAttribute('data-lang-add')
          : addToCartBtn.getAttribute('data-lang-sold-out');
      }
      if (unavailableNote) unavailableNote.hidden = true;
    } else {
      if (variantIdInput) variantIdInput.value = '';
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = addToCartBtn.getAttribute('data-lang-unavailable');
      }
      if (unavailableNote) unavailableNote.hidden = false;
    }
  }

  // Bound once per drawer (guarded below) since `content`'s own node is never
  // replaced across opens — only its innerHTML is swapped per product — so a
  // single delegated listener handles every future quick view without
  // re-registering (and leaking) a new one on each open.
  function initQuickviewPanel(content, drawer) {
    if (content.dataset.quickviewBound === 'true') return;
    content.dataset.quickviewBound = 'true';

    content.addEventListener('click', function (event) {
      var moreBtn = event.target.closest('[data-mc-quickview-swatch-more]');
      if (moreBtn) {
        var group = moreBtn.closest('[data-mc-quickview-option-group]');
        var swatches = group && group.querySelector('.mc-quickview__swatches');
        if (swatches) swatches.setAttribute('data-expanded', 'true');
        moreBtn.setAttribute('aria-expanded', 'true');
        return;
      }

      var optionBtn = event.target.closest('[data-mc-quickview-option]');
      if (!optionBtn || optionBtn.getAttribute('aria-pressed') === 'true') return;
      var group = optionBtn.closest('[data-mc-quickview-option-group]');
      if (!group) return;

      var buttons = group.querySelectorAll('[data-mc-quickview-option]');
      for (var b = 0; b < buttons.length; b += 1) {
        var isActive = buttons[b] === optionBtn;
        if (buttons[b].classList.contains('mc-card__swatch')) {
          buttons[b].classList.toggle('mc-card__swatch--active', isActive);
        } else if (buttons[b].classList.contains('mc-quickview__chip')) {
          buttons[b].classList.toggle('mc-quickview__chip--active', isActive);
        }
        buttons[b].setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }

      var valueLabel = group.querySelector('[data-mc-quickview-option-value]');
      if (valueLabel) valueLabel.textContent = optionBtn.getAttribute('data-option-value');

      updateQuickviewSelection(content);
    });

    content.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-mc-quickview-form]');
      if (!form || !drawer) return;

      var addToCartBtn = form.querySelector('[data-mc-quickview-add-to-cart]');
      if (addToCartBtn) addToCartBtn.classList.add('mc-quickview__add-to-cart--loading');

      function cleanup() {
        document.removeEventListener('cart:item-added', onAdded);
        document.removeEventListener('cart:add-error', onError);
        if (addToCartBtn) addToCartBtn.classList.remove('mc-quickview__add-to-cart--loading');
      }

      function onAdded() {
        cleanup();
        drawer.close();
      }

      function onError() {
        cleanup();
      }

      document.addEventListener('cart:item-added', onAdded);
      document.addEventListener('cart:add-error', onError);
    });
  }

  class MainCollectionAppElement extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-mc-form]');
      this.results = this.querySelector('[data-mc-results]');
      this.announce = this.querySelector('[data-mc-announce]');
      this.sectionId = this.getAttribute('data-section-id');
      this._abortController = null;
      this._debounceTimer = null;

      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('change', this._onChange.bind(this));
      if (this.form) this.form.addEventListener('submit', this._onSubmit.bind(this));

      var self = this;
      window.addEventListener('popstate', function () {
        self._requestUpdate(window.location.href, { pushHistory: false });
      });
    }

    _onClick(event) {
      var swatchBtn = event.target.closest('[data-mc-swatch]');
      if (swatchBtn) {
        this._onSwatchClick(swatchBtn);
        return;
      }

      var quickviewTrigger = event.target.closest('[data-mc-quickview]');
      if (quickviewTrigger) {
        event.preventDefault();
        this._openQuickview(quickviewTrigger);
        return;
      }

      var drawerOpenBtn = event.target.closest('[data-mc-drawer-open]');
      if (drawerOpenBtn) {
        var targetId = drawerOpenBtn.getAttribute('data-mc-drawer-open');
        var drawer = document.getElementById(targetId);
        if (drawer && typeof drawer.open === 'function') {
          drawer.open(drawerOpenBtn);
        }
        return;
      }

      var clearPriceBtn = event.target.closest('[data-mc-clear-price]');
      if (clearPriceBtn && this.form) {
        var priceInputs = this.form.querySelectorAll('.mc-facets__price-input');
        for (var i = 0; i < priceInputs.length; i += 1) {
          priceInputs[i].value = '';
        }
        clearTimeout(this._debounceTimer);
        this._requestUpdate(this._buildUrlFromForm());
        return;
      }

      var ajaxLink = event.target.closest('[data-mc-ajax]');
      if (ajaxLink && ajaxLink.tagName === 'A' && ajaxLink.getAttribute('href')) {
        event.preventDefault();
        clearTimeout(this._debounceTimer);
        this._requestUpdate(ajaxLink.href);
      }
    }

    _onChange(event) {
      var target = event.target;

      if (target.matches('[data-mc-sort]')) {
        clearTimeout(this._debounceTimer);
        this._requestUpdate(this._buildUrlFromForm());
        var sortDrawer = target.closest('main-collection-drawer');
        if (sortDrawer && typeof sortDrawer.close === 'function') sortDrawer.close();
        return;
      }

      if (target.matches('[data-mc-filter]')) {
        clearTimeout(this._debounceTimer);
        var self = this;
        this._debounceTimer = setTimeout(function () {
          self._requestUpdate(self._buildUrlFromForm());
        }, 350);
      }
    }

    _openQuickview(trigger) {
      var drawer = document.getElementById('mc-quickview-' + this.sectionId);
      if (!drawer || typeof drawer.open !== 'function') return;

      var card = trigger.closest('[data-mc-card]');
      var template = card && card.querySelector('[data-mc-quickview-template]');
      var content = drawer.querySelector('[data-mc-quickview-content]');
      if (!template || !content) return;

      content.innerHTML = '';
      content.appendChild(template.content.cloneNode(true));
      initQuickviewPanel(content, drawer);
      drawer.open(trigger);
    }

    _onSwatchClick(swatchBtn) {
      var card = swatchBtn.closest('[data-mc-card]');
      if (!card) return;

      var swatchGroup = swatchBtn.closest('[data-mc-swatches]');
      if (swatchGroup) {
        var siblings = swatchGroup.querySelectorAll('[data-mc-swatch]');
        for (var i = 0; i < siblings.length; i += 1) {
          siblings[i].classList.remove('mc-card__swatch--active');
          siblings[i].setAttribute('aria-pressed', 'false');
        }
      }
      swatchBtn.classList.add('mc-card__swatch--active');
      swatchBtn.setAttribute('aria-pressed', 'true');

      var variantUrl = swatchBtn.getAttribute('data-variant-url');
      if (variantUrl) {
        var titleLink = card.querySelector('.mc-card__title-link');
        if (titleLink) titleLink.href = variantUrl;

        var quickviewLink = card.querySelector('[data-mc-quickview]');
        if (quickviewLink) {
          quickviewLink.href = variantUrl;
          quickviewLink.setAttribute('data-product-url', variantUrl);
        }
      }

      var mediaId = swatchBtn.getAttribute('data-media-id');
      if (mediaId) {
        var media = card.querySelector('mc-card-media');
        if (media && typeof media.showMedia === 'function') {
          media.showMedia(
            mediaId,
            swatchBtn.getAttribute('data-image-src'),
            swatchBtn.getAttribute('data-image-alt')
          );
        }
      }

      var variantId = swatchBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      this._applyVariantTemplate(card, 'mc-badges-template', '[data-mc-badges]', variantId);
      this._applyVariantTemplate(card, 'mc-price-template', '.mc-card__price', variantId);
    }

    _applyVariantTemplate(card, templateAttr, targetSelector, variantId) {
      var template = card.querySelector('[data-' + templateAttr + '][data-variant-id="' + variantId + '"]');
      var target = card.querySelector(targetSelector);
      if (!template || !target) return;

      target.innerHTML = '';
      target.appendChild(template.content.cloneNode(true));
    }

    _onSubmit(event) {
      event.preventDefault();
      clearTimeout(this._debounceTimer);
      this._requestUpdate(this._buildUrlFromForm());
    }

    _buildUrlFromForm() {
      if (!this.form) return window.location.pathname;

      var params = new URLSearchParams();
      var formData = new FormData(this.form);
      formData.forEach(function (value, key) {
        if (value === '') return;
        params.append(key, value);
      });

      var action = this.form.getAttribute('action') || window.location.pathname;
      var query = params.toString();
      return query ? action + '?' + query : action;
    }

    _captureFocus() {
      var active = document.activeElement;
      var facetsBody = this.querySelector('[data-mc-facets-body]');
      if (!facetsBody || !active || !facetsBody.contains(active)) return null;

      return {
        name: active.getAttribute('name'),
        value: active.getAttribute('value')
      };
    }

    _restoreFocus(descriptor) {
      if (!descriptor || !descriptor.name) return;
      var facetsBody = this.querySelector('[data-mc-facets-body]');
      if (!facetsBody) return;

      var selector = '[name="' + CSS.escape(descriptor.name) + '"]';
      if (descriptor.value) {
        selector += '[value="' + CSS.escape(descriptor.value) + '"]';
      }

      var match = facetsBody.querySelector(selector);
      if (match) match.focus();
    }

    _requestUpdate(url, options) {
      if (!url) return;
      var opts = options || {};
      var pushHistory = opts.pushHistory !== false;

      if (this._abortController) this._abortController.abort();
      this._abortController = new AbortController();

      var fetchUrl = new URL(url, window.location.origin);
      if (this.dataset.mcForceAvailability === 'true' && !fetchUrl.searchParams.has('filter.v.availability')) {
        fetchUrl.searchParams.set('filter.v.availability', '1');
        url = fetchUrl.pathname + fetchUrl.search;
      }
      fetchUrl.searchParams.set('section_id', this.sectionId);

      this.setAttribute('data-mc-loading', '');
      this.setAttribute('aria-busy', 'true');

      var self = this;
      var focusDescriptor = this._captureFocus();

      fetch(fetchUrl.toString(), { signal: this._abortController.signal, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('main-collection: request failed');
          return response.text();
        })
        .then(function (html) {
          self._applyResponse(html, url, pushHistory);
          self._restoreFocus(focusDescriptor);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          window.location.href = url;
        })
        .finally(function () {
          self.removeAttribute('data-mc-loading');
          self.removeAttribute('aria-busy');
        });
    }

    _applyResponse(html, canonicalUrl, pushHistory) {
      var doc = new DOMParser().parseFromString(html, 'text/html');

      var openGroups = [];
      var currentGroups = this.querySelectorAll('.mc-facets__group[open]');
      for (var g = 0; g < currentGroups.length; g += 1) {
        openGroups.push(currentGroups[g].getAttribute('data-mc-group'));
      }

      var newFacetsBody = doc.querySelector('[data-mc-facets-body]');
      var currentFacetsBody = this.querySelector('[data-mc-facets-body]');
      if (newFacetsBody && currentFacetsBody) {
        currentFacetsBody.replaceWith(newFacetsBody);
        var newGroups = newFacetsBody.querySelectorAll('.mc-facets__group');
        for (var n = 0; n < newGroups.length; n += 1) {
          var key = newGroups[n].getAttribute('data-mc-group');
          if (openGroups.indexOf(key) === -1) {
            newGroups[n].removeAttribute('open');
          }
        }
      }

      var newResults = doc.querySelector('[data-mc-results]');
      if (newResults && this.results) {
        this.results.replaceWith(newResults);
        this.results = newResults;
      }

      var countText = '';
      var newCount = doc.querySelector('[data-mc-count]');
      if (newCount) {
        countText = newCount.textContent;
        var currentCount = this.querySelector('[data-mc-count]');
        if (currentCount) currentCount.textContent = countText;
      }

      var newSortLabel = doc.querySelector('[data-mc-sort-label]');
      if (newSortLabel) {
        var currentSortLabel = this.querySelector('[data-mc-sort-label]');
        if (currentSortLabel) currentSortLabel.textContent = newSortLabel.textContent;
      }

      var newFilterCount = doc.querySelector('[data-mc-filter-count]');
      var filterButton = this.querySelector('.mc-toolbar__button--filter');
      if (filterButton) {
        var existingBadge = filterButton.querySelector('[data-mc-filter-count]');
        if (newFilterCount) {
          if (existingBadge) {
            existingBadge.textContent = newFilterCount.textContent;
          } else {
            filterButton.insertAdjacentHTML('beforeend', newFilterCount.outerHTML);
          }
        } else if (existingBadge) {
          existingBadge.remove();
        }
      }

      if (this.announce) this.announce.textContent = countText;

      if (pushHistory) {
        try {
          var historyUrl = new URL(canonicalUrl, window.location.origin);
          historyUrl.searchParams.delete('section_id');
          window.history.pushState({}, '', historyUrl.pathname + historyUrl.search);
        } catch (error) {
          /* noop */
        }
      }

      this.dispatchEvent(new CustomEvent('main-collection:updated', { bubbles: true }));
    }
  }

  if (!customElements.get('main-collection-app')) {
    customElements.define('main-collection-app', MainCollectionAppElement);
  }

  var LONG_PRESS_MS = 450;
  var PRESS_MOVE_TOLERANCE = 10;

  class MainCollectionCardMediaElement extends HTMLElement {
    connectedCallback() {
      this.swiperInstance = null;
      this.initialized = false;
      this.swiperReadyAttempts = 0;
      this._pressTimer = null;
      this._pressStart = null;
      this._suppressClick = false;
      this._dismissTimer = null;

      this._onPointerDown = this._onPointerDown.bind(this);
      this._onPointerMove = this._onPointerMove.bind(this);
      this._onPointerUp = this._onPointerUp.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);
      this._onContextMenu = this._onContextMenu.bind(this);

      this.addEventListener('pointerdown', this._onPointerDown);
      this.addEventListener('pointermove', this._onPointerMove);
      this.addEventListener('pointerup', this._onPointerUp);
      this.addEventListener('pointercancel', this._onPointerUp);
      this.addEventListener('click', this._onClickCapture, true);
      this.addEventListener('contextmenu', this._onContextMenu);

      this._cardEl = this.closest('[data-mc-card]');
      if (this._cardEl) {
        this._onCardClick = this._onCardClick.bind(this);
        this._cardEl.addEventListener('click', this._onCardClick);
      }

      if (this.dataset.hasCarousel === 'true') {
        if ('IntersectionObserver' in window) {
          var self = this;
          this._observer = new IntersectionObserver(
            function (entries) {
              var isNear = entries.some(function (entry) {
                return entry.isIntersecting;
              });
              if (isNear) {
                self._observer.disconnect();
                self.initSwiper();
              }
            },
            { rootMargin: '200px 0px' }
          );
          this._observer.observe(this);
        } else {
          this.initSwiper();
        }
      }
    }

    disconnectedCallback() {
      this._clearPressTimer();
      this._clearDismissTimer();
      if (this._observer) this._observer.disconnect();
      if (this._cardEl) {
        this._cardEl.removeEventListener('click', this._onCardClick);
        this._cardEl = null;
      }
      this.destroySwiper();
    }

    _onCardClick(event) {
      if (event.defaultPrevented) return;
      if (event.target.closest('a, button, input, select, textarea, label, [data-mc-swatches]')) return;

      var link = this._cardEl && this._cardEl.querySelector('.mc-card__title-link');
      if (!link) return;

      // Re-dispatch as a click on the real title link so the global page
      // transition script and modifier-key clicks behave exactly as if the
      // title had been clicked.
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
          button: 0,
          ctrlKey: event.ctrlKey,
          metaKey: event.metaKey,
          shiftKey: event.shiftKey,
          altKey: event.altKey
        })
      );
    }

    initSwiper() {
      if (this.initialized) return;

      if (typeof Swiper === 'undefined') {
        if (this.swiperReadyAttempts >= 40) return;
        this.swiperReadyAttempts += 1;
        var self = this;
        setTimeout(function () {
          self.initSwiper();
        }, 50);
        return;
      }

      var swiperEl = this.querySelector('[data-mc-swiper]');
      if (!swiperEl) return;

      var cardEl = this.closest('[data-mc-card]');
      var paginationEl = cardEl && cardEl.querySelector('[data-mc-pagination]');
      var maxDots = 5;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.initialized = true;
      var self = this;

      this.swiperInstance = new Swiper(swiperEl, {
        speed: reducedMotion ? 0 : 320,
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        pagination: paginationEl
          ? {
            el: paginationEl,
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              var size = Math.min(maxDots, total);
              var start = Math.min(Math.max(current - 1 - Math.floor(size / 2), 0), total - size);
              var html = '';
              for (var i = start; i < start + size; i += 1) {
                var classes = 'mc-card__dot';
                if (i === current - 1) classes += ' mc-card__dot--active';
                else if ((i === start && start > 0) || (i === start + size - 1 && start + size < total)) {
                  classes += ' mc-card__dot--small';
                }
                html += '<button type="button" class="' + classes + '" data-mc-dot="' + i + '" aria-label="Image ' + (i + 1) + ' of ' + total + '"' + (i === current - 1 ? ' aria-current="true"' : '') + '></button>';
              }
              return html;
            }
          }
          : false
      });

      if (paginationEl) {
        this._paginationEl = paginationEl;
        this._onDotClick = function (event) {
          var dot = event.target.closest('[data-mc-dot]');
          if (!dot || !self.swiperInstance) return;
          self.swiperInstance.slideTo(parseInt(dot.getAttribute('data-mc-dot'), 10));
        };
        paginationEl.addEventListener('click', this._onDotClick);
      }

      this._arrowEls = Array.prototype.slice.call(this.querySelectorAll('[data-mc-arrow]'));
      this._onArrowClick = function (event) {
        if (!self.swiperInstance) return;
        if (event.currentTarget.getAttribute('data-mc-arrow') === 'prev') self.swiperInstance.slidePrev();
        else self.swiperInstance.slideNext();
      };
      this._arrowEls.forEach(function (arrow) {
        arrow.addEventListener('click', self._onArrowClick);
      });
    }

    destroySwiper() {
      if (this._arrowEls) {
        var owner = this;
        this._arrowEls.forEach(function (arrow) {
          arrow.removeEventListener('click', owner._onArrowClick);
        });
        this._arrowEls = null;
      }
      if (this._paginationEl) {
        this._paginationEl.removeEventListener('click', this._onDotClick);
        this._paginationEl.innerHTML = '';
        this._paginationEl = null;
      }
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      this.initialized = false;
    }

    showMedia(mediaId, imageSrc, imageAlt) {
      if (this.dataset.hasCarousel !== 'true') {
        this._swapSingleImage(imageSrc, imageAlt);
        return;
      }

      var target = this.querySelector('.mc-card__slide[data-media-id="' + mediaId + '"]');

      if (!this.initialized) {
        if (this._observer) this._observer.disconnect();
        this.initSwiper();
      }

      if (!target) {
        // The card only renders the first few product images; append the
        // swatch's own image as an extra slide when it was cut off.
        var wrapper = this.querySelector('.swiper-wrapper');
        if (!wrapper || !imageSrc) return;
        target = document.createElement('div');
        target.className = 'swiper-slide mc-card__slide';
        target.setAttribute('data-media-id', mediaId);
        var img = document.createElement('img');
        img.src = imageSrc;
        img.alt = imageAlt || '';
        img.style.cssText = 'width:100%;height:100%;object-fit:cover';
        img.loading = 'eager';
        target.appendChild(img);
        wrapper.appendChild(target);
        if (this.swiperInstance) this.swiperInstance.update();
      }

      var self = this;
      var attempts = 0;
      (function waitForSwiper() {
        if (self.swiperInstance) {
          var index = Array.prototype.indexOf.call(self.swiperInstance.slides, target);
          if (index > -1) {
            var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            self.swiperInstance.slideTo(index, reducedMotion ? 0 : 250);
          }
          return;
        }
        attempts += 1;
        if (attempts < 40) setTimeout(waitForSwiper, 50);
      })();
    }

    _swapSingleImage(imageSrc, imageAlt) {
      if (!imageSrc) return;
      var img = this.querySelector('.mc-card__image img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = imageSrc;
      img.alt = imageAlt || '';
    }

    _onPointerDown(event) {
      if (event.pointerType === 'mouse') return;
      if (event.target.closest('[data-mc-quickview]')) return;

      this._pressStart = { x: event.clientX, y: event.clientY };
      this._clearPressTimer();

      var self = this;
      this._pressTimer = setTimeout(function () {
        self._pressTimer = null;
        self._suppressClick = true;
        self._revealQuickview();
      }, LONG_PRESS_MS);
    }

    _onPointerMove(event) {
      if (!this._pressStart) return;
      var dx = Math.abs(event.clientX - this._pressStart.x);
      var dy = Math.abs(event.clientY - this._pressStart.y);
      if (dx > PRESS_MOVE_TOLERANCE || dy > PRESS_MOVE_TOLERANCE) {
        this._clearPressTimer();
      }
    }

    _onPointerUp() {
      this._clearPressTimer();
    }

    _onClickCapture(event) {
      if (this._suppressClick) {
        this._suppressClick = false;
        // The long-press reveal puts the quickview trigger right where the
        // finger is resting, so the release's own click can land on the
        // now-visible trigger itself rather than the image behind it. Only
        // suppress the image click (the thing this exists to prevent —
        // treating the long-press release as "tap to open product") and let
        // a click that actually landed on the trigger open quick view.
        if (event.target.closest('[data-mc-quickview]')) return;
        event.preventDefault();
        event.stopPropagation();
      }
    }

    _onContextMenu(event) {
      if (this._pressTimer || this.getAttribute('data-quickview-active') === 'true') {
        event.preventDefault();
      }
    }

    _revealQuickview() {
      this.setAttribute('data-quickview-active', 'true');
      this._clearDismissTimer();
      var self = this;
      this._dismissTimer = setTimeout(function () {
        self.removeAttribute('data-quickview-active');
      }, 4000);
    }

    _clearPressTimer() {
      if (this._pressTimer) {
        clearTimeout(this._pressTimer);
        this._pressTimer = null;
      }
      this._pressStart = null;
    }

    _clearDismissTimer() {
      if (this._dismissTimer) {
        clearTimeout(this._dismissTimer);
        this._dismissTimer = null;
      }
    }
  }

  if (!customElements.get('mc-card-media')) {
    customElements.define('mc-card-media', MainCollectionCardMediaElement);
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var activeCards = document.querySelectorAll('mc-card-media[data-quickview-active="true"]');
      for (var i = 0; i < activeCards.length; i += 1) {
        if (!activeCards[i].contains(event.target)) {
          activeCards[i].removeAttribute('data-quickview-active');
        }
      }
    },
    true
  );
})();
